import { useEffect, useRef } from "react";
import gsap from "gsap";

export function SignalCursor({ className = "" }: { className?: string }) {
  const cursorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const cursor = cursorRef.current;
    if (
      !cursor ||
      window.matchMedia("(pointer: coarse)").matches ||
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }

    const xTo = gsap.quickTo(cursor, "x", { duration: 0.18, ease: "power3.out" });
    const yTo = gsap.quickTo(cursor, "y", { duration: 0.18, ease: "power3.out" });
    gsap.set(cursor, { xPercent: -50, yPercent: -50 });

    const move = (event: PointerEvent) => {
      xTo(event.clientX);
      yTo(event.clientY);
      cursor.dataset.visible = "true";
    };
    const leave = () => {
      cursor.dataset.visible = "false";
    };

    window.addEventListener("pointermove", move, { passive: true });
    document.documentElement.addEventListener("mouseleave", leave);
    return () => {
      window.removeEventListener("pointermove", move);
      document.documentElement.removeEventListener("mouseleave", leave);
    };
  }, []);

  return (
    <div ref={cursorRef} className={`signal-cursor ${className}`.trim()} aria-hidden="true">
      <i />
    </div>
  );
}
